import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Integrated",
  "use": "Integrated-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"Integrated\"><g fill=\"none\"><circle fill=\"currentColor\" cx=\"10\" cy=\"10\" r=\"10\" /><path fill=\"#FFF\" d=\"M10.048 1.429l-5.041 9.998h4.996l.062 7.144 4.937-10.01h-5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol